import browse from './browse.vue';

export default { browse };
